import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=3b6ac8de&scoped=true"
import script from "./QuestionPreview.vue?vue&type=script&lang=js"
export * from "./QuestionPreview.vue?vue&type=script&lang=js"
import style0 from "./QuestionPreview.vue?vue&type=style&index=0&id=3b6ac8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ac8de",
  null
  
)

export default component.exports